Monitoring.Views ||= {}

class AccountSettings.LoginSettingView extends Backbone.View
  template: JST["backbone/templates/account_settings/login_setting/login_setting"]

  events:
    'click #login-setting-save': 'onClickSave'
    'change #login-setting-active': 'onLoginSettingActiveChange'
    'input #input-realm': 'onRealmChange'
    'input #input-login-code': 'onLoginCodeChange'
    'input #input-client-id': 'onClientIdChange'
    'input #input-client-secret': 'onClientSecretChange'
    'input #input-expiration': 'onExpirationChange'

  initialize: (@options = {}) ->
    @loginSetting = @options.loginSetting || @defaultSettings()

  render: =>
    @$el.html(@template(loginSetting: @loginSetting, canSave: @canSave()))
    @initializeToggle()

  initializeToggle: ->
    @$el.find('#login-setting-active').bootstrapToggle({
      # 'on' and 'off' options can be set here
    })

  onLoginSettingActiveChange: ->
    @loginSetting.active = @$el.find("#login-setting-active").prop('checked')

  onRealmChange: (event) ->
    @loginSetting.realm = @$el.find(event.target).val()
    @validateSave()

  onLoginCodeChange: (event) ->
    @loginSetting.login_code = @$el.find(event.target).val()
    @validateSave()

  onClientIdChange: (event) ->
    @loginSetting.client_id = @$el.find(event.target).val()
    @validateSave()

  onClientSecretChange: (event) ->
    @loginSetting.client_secret = @$el.find(event.target).val()
    @validateSave()

  onExpirationChange: (event) ->
    @loginSetting.expiration = @$el.find(event.target).val()
    @validateSave()

  onClickSave: (event) =>
    event.stopPropagation();
    $.post('/keepcon/settings/account_settings/save_login_setting', @loginSetting, (response) =>
      if response.success
        window.showSuccess(I18n.t('monitoring.login_setting.save_success'))
      else
        window.showError(response.message)
    )

  validateSave: =>
    if @canSave()
      @enableSave()
    else
      @disableSave()

  hasValidRealm: =>
    @isValid(@loginSetting.realm)

  hasValidLoginCode: =>
    @isValid(@loginSetting.login_code)

  hasValidClientId: =>
    @isValid(@loginSetting.client_id)

  hasValidClientSecret: =>
    @isValid(@loginSetting.client_secret)

  hasValidExpiration: =>
    @isValid(@loginSetting.expiration)

  isValid: (value) =>
    value != null && value != ''

  canSave: =>
    @hasValidRealm() && @hasValidLoginCode() && @hasValidClientId() && @hasValidClientSecret() && @hasValidExpiration()

  enableSave: =>
    @$el.find("#login-setting-save").prop("disabled", false);

  disableSave: =>
    @$el.find("#login-setting-save").prop("disabled", true);

  defaultSettings: ->
    {
      active: false,
      client_id: '',
      client_secret: '',
      realm: '',
      login_code: '',
      expiration: 87660,
      account_setting_id: 0
    }
